import { ChangeDetectorRef, Component, ContentChild, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, Subscriber } from 'rxjs';
import { isNullOrUndefined } from 'src/app/shared/utilities';

declare type option = { text: string, value: any };
declare type formatType = 'value' | 'text' | 'valuetext' | 'multiCommaValue';
export const VIS_CB_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => VisMultiComboboxComponent),
  multi: true
};
@Component({
  selector: 'app-vis-multicombobox',
  templateUrl: './vis-multicombobox.component.html',
  styleUrls: ['./vis-multicombobox.component.css'],
  providers: [VIS_CB_CONTROL_VALUE_ACCESSOR]
})
export class VisMultiComboboxComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @ContentChild(TemplateRef)
  displayTmp: TemplateRef<any>;
  @Input()
  data: option[];
  @Input()
  allowCustom: Boolean;
  @Input()
  allowInput: Boolean = true;
  @Input()
  filterable: Boolean;
  @Input()
  textField: string = 'text';
  @Input()
  valueField: string = 'value';
  @Input()
  valuePrimitive: Boolean;
  @Input()
  emitPrev: boolean;
  @Input()
  panelFitContent: Boolean;
  @Input()
  value?: string;
  @Input()
  multiMaxItemCount?: number = null;
  // 下拉選單最多顯示幾筆；未設定時不限制總筆數。
  @Input()
  maxVisibleOptions?: number = null;
  // 尚未輸入搜尋文字時，是否先顯示選項。
  @Input()
  showOptionsBeforeSearch = true;
  // 每次加入畫面的選項筆數；未設定時一次顯示全部。
  @Input()
  optionsPerBatch?: number = null;
  // 用於combobox 之綁定不用ngModel
  @Input()
  set othersetvalue(val: any) {
    this.writeValue(val);
  }
  /**
   * 顯示方式 value:只顯示值 text:只顯示文字 valuetext:顯示值+文字
   * @type {formatType} 'value'|'text'|'valuetext'
   * @memberof VisMultiComboboxComponent
   */
  @Input()
  valueFormat: formatType;

  @Input()
  defaultValue: any;

  @Input()
  disabled: false;

  @Input()
  ignoreCase = true;
  @Input()
  // 處理輸入的值帶不在其 ComboBOX之data時
  set setNotInComboData(v: boolean) {
    this._setNotInComboData = v
  }

  @Input() customClass?: string = '';
  @Output()
  filterChange: EventEmitter<any> = new EventEmitter(false);
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter(false);

  @ViewChild('input')
  inputElement: ElementRef<HTMLInputElement>
  @ViewChild('input', { read: MatAutocompleteTrigger })
  autoComplete: MatAutocompleteTrigger;
  @ViewChild('auto')
  dropdownAutocomplete: MatAutocomplete;
  _setNotInComboData: boolean;
  _currentValue: any;
  _prevValue: any;
  _onChange: (value) => {};
  _onTouched: () => {};
  _disabled: boolean;
  _displayText = '';
  _class: string;
  isHiddenClickButton = true;
  filteredOptions: Observable<option[]>;
  options: Subscriber<option[]>;
  // 表示目前搜尋結果是否還有下一批尚未顯示。
  hasMoreOptionsToShow = false;
  // 保留目前搜尋條件與顯示筆數，捲動載入下一批時可直接接續。
  private lastSearchText = '';
  private lastSearchField = '';
  private numberOfOptionsToShow = 0;
  // MatAutocomplete 開啟後所建立的實際捲動容器。
  private dropdownPanel: HTMLElement = null;
  // 距離清單底部小於此像素值時，開始顯示下一批。
  private readonly loadMoreDistanceFromBottom = 96;
  constructor(private elementRef: ElementRef, private cd: ChangeDetectorRef) {

  }

  optInit = false;
  ngOnInit(): void {
    this._disabled = this.disabled;
    if (this.defaultValue != null) this._currentValue = this.defaultValue;

    this.filteredOptions = new Observable(subscriber => {
      this.options = subscriber;
      this.updateDisplayedOptions(this._displayText, this.textField);
      if (this.data) {
        if (this.valueFormat != undefined) {
          for (var x of this.data) {
            if (x[this.textField]) {
              // string || number

              if ((typeof (x[this.valueField]) == 'string' && !!x[this.valueField]) || (typeof (x[this.valueField]) == 'number')) {
                x[this.textField] = x[this.textField].indexOf('|') > 0 ? x[this.textField] : x[this.valueField] + " | " + x[this.textField]
              }
            }

            if (this._currentValue == x.value && this.valueFormat !== 'multiCommaValue') {
              this.setDisplayText(this.valueFormat, x.text);
            }
            else if (this.valueFormat === 'multiCommaValue') {
              this.setDisplayText(this.valueFormat, this._currentValue);
            }
          }
        }
        else {
          this.setDisplayText(this.valueFormat, (this.data.find(x => x[this.valueField] == this._currentValue) || {})[this.textField] || '');
        }
        this.updateDisplayedOptions('', this.valueField);
        this.optInit = true;
      }
    });
  }

  ngAfterContentChecked() {

    this._class = this.elementRef.nativeElement.className;

  }

  inputChange() {
    var text = this.inputElement.nativeElement.value;
    if (this.allowInput) {
      if (this.valueFormat === 'multiCommaValue' && text.length > 0) {
        if (text.length > 0) {
          let numberStrings = text.split(",").map((value) => value.trim());
          let resultArray: string[] = numberStrings.map((str) => `${str}`);

          if (resultArray.length > 0) {
            let last = resultArray[(resultArray.length - 1)];
            this.updateDisplayedOptions(last, this.valueField);
            
          }
          else this.updateDisplayedOptions(text, this.valueField);
        }
      }
      else this.updateDisplayedOptions(text, this.valueField);
    } else {
      this.inputElement.nativeElement.value = this._displayText;
    }
  }

  onInputClick() {
    this.openPanel();
  }

  writeValue(obj: any): void {
    //console.log('writeValue',obj,this.data)
    if (!isNullOrUndefined(obj)) {
      this._prevValue = this._currentValue;
      this._currentValue = obj;
      if (this.valueFormat !== 'multiCommaValue') {
        var item = this.data?.find(d => d[this.valueField] == this._currentValue)
        var text = item ? item[this.textField] ?? '' : '';

        // 處理輸入的值帶不在其 ComboBOX之data時
        if (this._setNotInComboData && text == '') {

          text = this._currentValue;
        }
        // 還沒Init完成就跳過，等Init完成時會在設定一次顯示文字
        if (this.optInit) {
          this.setDisplayText(this.valueFormat, text);
        }
        this.updateDisplayedOptions(this._displayText, this.textField);

      }
      else {
        var stringM = (this._currentValue?.toLowerCase()).toString() || '';
        let items: option[] = [];
        let last = '';
        if (stringM.length > 0) {
          let numberStrings = stringM.split(",").map((value) => value.trim());
          let resultArray: string[] = numberStrings.map((str) => `${str}`);
          for (var i = 0; i < resultArray.length; i++) {
            //  console.log('i',resultArray[i]);
            let x = this.data.find(d => d[this.valueField] == resultArray[i].toUpperCase());
            if (x && x[this.valueField]?.trim().length > 0 && items.length < 4 && !items.includes(x)) items.push(x);
            // console.log('items',items);
          }
          last = resultArray[resultArray.length > 0 ? resultArray.length - 1 : 0] || '';
          if (items.length > 0) {
            let str = items.map(x => x[this.valueField]);
            let spec = str.join(',');
            //  if (spec.length >0 )spec += ',';
            this._prevValue = this._currentValue;
            this._currentValue = spec;
            // this.autoComplete.closePanel();
            // this.options.next(this.data);          return;
          }
          else this._currentValue = ''
        }
        else this._currentValue = ''
        if (this.optInit) {
          this.setDisplayText(this.valueFormat, this._currentValue);
        }
        this.updateDisplayedOptions(last, this.valueField);
      }
    } else {
      // clear
      this._prevValue = this._currentValue;
      this._currentValue = obj;
      this._displayText = '';
    }
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  optSelected(evt: MatAutocompleteSelectedEvent) {
    let isCommavalue = false;
    this._prevValue = this._currentValue;

    if (this.valueFormat === 'multiCommaValue') {

      var stringM: string = (this._currentValue || '').toString();
      // var tt :option[] = [];
      if (stringM.length > 0) {
        isCommavalue = true;
      }
    }
    if (!isCommavalue) {
      this._currentValue = evt?.option?.value;
      var item = this.data.find(d => d.value == this._currentValue)
      setTimeout(() => {

        this.setDisplayText(this.valueFormat, this._currentValue);
      }, 0);
    }
    else {
      let splitValue = stringM.split(",");
      if (!this.multiMaxItemCount || splitValue.length < this.multiMaxItemCount)
        this._currentValue = stringM + ',' + evt?.option?.value;

      setTimeout(() => {
        this.setDisplayText(this.valueFormat, this._currentValue ?? '');
      }, 1);
    }

    if (this._onChange) {
      this._onChange(this._currentValue)
    }

    if (this.valuePrimitive && !isCommavalue) {

      if (this.emitPrev) {
        this.valueChange.emit({ value: evt?.option?.value, prev: this._prevValue });
      } else {
        this.valueChange.emit(evt?.option?.value);
      }
    }
    else if (this.valuePrimitive && isCommavalue) {
      if (this.emitPrev) {
        this.valueChange.emit({ value: evt?.option?.value, prev: this._prevValue });
      } else {
        this.valueChange.emit(this._currentValue);
      }
    }
    else if (!this.valuePrimitive && isCommavalue) {
      if (this.emitPrev) {
        this.valueChange.emit({ value: evt?.option, prev: pItem });
      } else {
        setTimeout(() => {
          this.valueChange.emit(this._currentValue);
        }, 2);

      }
    }
    else {
      if (this.emitPrev) {
        var pItem = this.data.find(d => d.value == this._prevValue)
        this.valueChange.emit({ value: evt?.option, prev: pItem });
      } else {
        this.valueChange.emit(evt?.option);
      }
    }


  }

  _valueChange(evt: Event) {

    var item: option = null;
    var items: option[] = [];
    let isCommavalue = false;
    switch (this.valueFormat) {
      case 'multiCommaValue':
        item = this.data.find(d => d[this.valueField]?.toLowerCase() == evt.target['value']?.toLowerCase());
        break;
      case 'valuetext':
        item = this.data.find(d => (d[this.valueField] + '' + d[this.textField])?.toLowerCase() == evt.target['value']?.toLowerCase());
        break;
      case 'value':
        item = this.data.find(d => d[this.valueField]?.toLowerCase() == evt.target['value']?.toLowerCase());
        break;
      case 'text':
      default:
        item = this.data.find(d => d[this.valueField]?.toLowerCase() == evt.target['value']?.toLowerCase());
        break;
    }
    if (this.valueFormat === 'multiCommaValue') {

      var stringM = (evt.target['value']?.toLowerCase()).toString() || '';
      if (stringM.length > 0) {
        let numberStrings = stringM.split(",").map((value) => value.trim());
        let resultArray: string[] = numberStrings.map((str) => `${str}`);
        for (var i = 0; i < resultArray.length; i++) {
          let x = this.data.find(d => d[this.valueField] == resultArray[i].toUpperCase());
          if (x && x[this.valueField]?.trim().length > 0 && items.length < 4 && !items.includes(x)) items.push(x);
        }
        if (items.length > 0) {
          let str = items.map(x => x[this.valueField]);
          let spec = str.join(',');
          this._prevValue = this._currentValue;
          this._currentValue = spec;
          isCommavalue = true;
        }
      }
    }
    if (!isCommavalue) {
      this._prevValue = this._currentValue;
      this._currentValue = item && item[this.valueField] ? item[this.valueField] : '';
      // 處理輸入的值帶不在其 ComboBOX之data時
      if (!item && this._setNotInComboData) {
        this._displayText = evt.target['value'];
        this._currentValue = evt.target['value'];
      }
      if (item && !this.ignoreCase) {

        this._displayText = item[this.textField];
      }
      if (!item && this.valueFormat === 'multiCommaValue') {
        this.setDisplayText(this.valueFormat, this._currentValue ?? '');
      }
    }
    else {
      this.setDisplayText(this.valueFormat, this._currentValue ?? '');
    }

    if (this._onChange) {
      this._onChange(this._currentValue)
    }
    if (this.valuePrimitive && !isCommavalue) {

      if (this.emitPrev) {
        this.valueChange.emit({ value: this._currentValue, prev: this._prevValue });
      } else {
        this.valueChange.emit(this._currentValue);
      }
    }
    if (this.valuePrimitive && isCommavalue) {

      if (this.emitPrev) {
        this.valueChange.emit({ value: this._currentValue, prev: this._prevValue });
      } else {
        this.valueChange.emit(this._currentValue);
      }
    }
    else if (!this.valuePrimitive && isCommavalue) {
      if (this.emitPrev) {
        var pItem = this.data.find(d => d[this.valueField] == this._prevValue)
        this.valueChange.emit({ value: this._currentValue, prev: pItem });
      } else {
        setTimeout(() => {
          this.valueChange.emit(this._currentValue);
        }, 1);

      }
    }
    else {
      if (this.emitPrev) {
        var pItem = this.data.find(d => d[this.valueField] == this._prevValue)
        this.valueChange.emit({ value: item, prev: pItem });
      } else {
        this.valueChange.emit(item ?? null);
      }
    }
  }

  simulateEnterKey(event: KeyboardEvent) {

    if (event.keyCode === 13) {
      // 模拟 Enter 键被按下
      this.autoComplete.closePanel();
      this.updateDisplayedOptions('', this.valueField);
    }
  }


  setDisplayText(_format: formatType, text: string) {
    var _content = text;
    var ret = '';
    switch (_format) {
      case 'value':
        ret = _content?.split('|')[0]
        if (ret == '' && _content != '') {
          ret = _content?.split('|')[1]
        }
        break
      case 'text':
        ret = _content?.split('|')[1]
        if (ret == '' && _content != '') {
          ret = _content?.split('|')[0]
        }
        break
      case 'multiCommaValue':
        ret = _content?.split('|')[0]
        if (ret == '' && _content != '') {
          ret = _content?.split('|')[1]
        }
        if (ret.length > 0) ret = ret[ret.length - 1] !== ',' ? ret + ',' : ret;

        break
      default:
        ret = '' + _content
        break
    }
    // 因為選取同一個選項時 MAT-AUTOCOMPLETE會把VALUE設定到INPUT中，而透過[VALUE]去綁定 UI不會去更新一樣的值
    // 所以用比較暴力的方式直接設定ELEMENT的VALUE

    setTimeout(() => {
      this._displayText = ret;
      this.inputElement.nativeElement.value = this._displayText;
    }, 0);
  }

  openPanel() {
    if (this._disabled) {
      return;
    }
    this.updateDisplayedOptions('', this.valueField);
    setTimeout(() => {
      this.autoComplete.openPanel();
    }, 0);

  }
  /**
   * 依搜尋文字篩選資料，再更新下拉選單目前要顯示的項目。
   * 這裡會同時套用總筆數上限與分批筆數，避免一次建立過多 DOM。
   */
  private updateDisplayedOptions(searchText: string, field: string): void {
    if (!this.options) {
      return;
    }

    const normalizedSearchText = (searchText || '').trim().toLowerCase();
    if (!normalizedSearchText && !this.showOptionsBeforeSearch) {
      this.lastSearchText = '';
      this.lastSearchField = field;
      this.numberOfOptionsToShow = 0;
      this.hasMoreOptionsToShow = false;
      this.options.next([]);
      return;
    }

    // 搜尋條件改變時，從第一批資料重新開始顯示。
    if (normalizedSearchText !== this.lastSearchText || field !== this.lastSearchField) {
      this.lastSearchText = normalizedSearchText;
      this.lastSearchField = field;
      this.numberOfOptionsToShow = this.optionsPerBatch || this.maxVisibleOptions || Number.MAX_SAFE_INTEGER;
    }

    // data 可能由非同步流程載入，第一次執行時尚未有值。
    const matchingOptions = (this.data || []).filter(item => {
      if (!normalizedSearchText) {
        return true;
      }
      const value = item?.[field];
      return value != null && String(value).toLowerCase().includes(normalizedSearchText);
    });

    const maximumNumberOfOptions = this.maxVisibleOptions == null ? matchingOptions.length : this.maxVisibleOptions;
    const numberOfOptionsToDisplay = Math.min(matchingOptions.length, maximumNumberOfOptions, this.numberOfOptionsToShow || maximumNumberOfOptions);
    this.hasMoreOptionsToShow = this.optionsPerBatch != null && numberOfOptionsToDisplay < Math.min(matchingOptions.length, maximumNumberOfOptions);
    this.options.next(matchingOptions.slice(0, numberOfOptionsToDisplay));
  }

  /** 將下一批選項加入目前顯示範圍。 */
  private showNextOptionsBatch(): void {
    if (!this.optionsPerBatch || !this.hasMoreOptionsToShow) {
      return;
    }

    this.numberOfOptionsToShow += this.optionsPerBatch;
    this.updateDisplayedOptions(this.lastSearchText, this.lastSearchField);
  }

  /** 下拉選單開啟後，開始監聽實際面板的捲動事件。 */
  startWatchingDropdownScroll(): void {
    this.removeDropdownScrollListener();
    // MatAutocomplete 的面板只有開啟後才會建立，因此必須安全地取得。
    this.dropdownPanel = this.dropdownAutocomplete?.panel?.nativeElement;
    this.dropdownPanel?.addEventListener('scroll', this.handleDropdownScroll);
  }

  /** 下拉選單關閉後，停止監聽捲動事件。 */
  stopWatchingDropdownScroll(): void {
    this.removeDropdownScrollListener();
  }

  /** 捲動接近清單底部時，自動加入下一批選項。 */
  private readonly handleDropdownScroll = (): void => {
    const panel = this.dropdownPanel;
    if (!panel || !this.hasMoreOptionsToShow) {
      return;
    }

    const distanceFromBottom = panel.scrollHeight - panel.scrollTop - panel.clientHeight;
    if (distanceFromBottom <= this.loadMoreDistanceFromBottom) {
      this.showNextOptionsBatch();
    }
  };

  /** 移除監聽並清除 DOM 參考，避免元件關閉後仍保留事件。 */
  private removeDropdownScrollListener(): void {
    this.dropdownPanel?.removeEventListener('scroll', this.handleDropdownScroll);
    this.dropdownPanel = null;
  }

  ngOnDestroy(): void {
    this.removeDropdownScrollListener();
  }

  /** 讓 Angular 以選項值識別項目，避免分批加入時重建既有 DOM。 */
  trackOptionByValue = (index: number, item: option): any => item?.[this.valueField] ?? index;

  getStyleObject() {
    return {
      'width': this.isHiddenClickButton ? 'calc(100%);' : 'calc(100% - 18px);',
    };
  }
}
